module.exports = __webpack_public_path__ + "4882db36d360c59f1b83717b3fe641a9.png";


//////////////////
// WEBPACK FOOTER
// ./assets/images/perks/floor_items/magic-staff.png
// module id = 2789
// module chunks = 0